import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { FaHome, FaTheaterMasks, FaUsers, FaCalendarAlt, FaBook } from 'react-icons/fa';
import { MdLightMode, MdDarkMode } from 'react-icons/md';
import { ReactCountryFlag } from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import LogoCM from '../composant/img/LogoCM.png';
import './Header.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';


function Top({ toggleTheme, isDarkMode }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const handleToggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleLinkClick = () => setIsMenuOpen(false);

  const handleLanguageChange = (language) => i18n.changeLanguage(language);

  return (
    <header className="header shadow-sm">
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-dark justify-content-between align-items-center">
          <Link className="navbar-brand d-flex align-items-center" to="/" onClick={handleLinkClick}>
            <img
              src={LogoCM}
              alt="LogoCM"
              className="fade-in"
            />
            <span className="ms-3 fw-bold text-white">Club LFI Tokyo</span>
          </Link>

          <button
            className={`navbar-toggler ${isMenuOpen ? 'collapsed' : ''}`}
            type="button"
            onClick={handleToggleMenu}
            aria-controls="navbarNav"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link text-white" to="/" onClick={handleLinkClick}>
                  <FaHome className="me-2" /> {t('home')}
                </Link>
              </li>

              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle text-white" href="#" data-bs-toggle="dropdown">
                  <FaUsers className="me-2" /> {t('clubs')}
                </a>
                <ul className="dropdown-menu bg-cyan">
                  <li><Link className="dropdown-item text-white" to="/Clubs" onClick={handleLinkClick}>{t('list_of_clubs')}</Link></li>
                  <li><Link className="dropdown-item text-white" to="/listeProjets" onClick={handleLinkClick}>{t('list_of_projects')}</Link></li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle text-white" href="#" data-bs-toggle="dropdown">
                  <FaTheaterMasks className="me-2" /> La Tribune
                </a>
                <ul className="dropdown-menu bg-cyan">
                  <li><Link className="dropdown-item text-white" to="/Journal" onClick={handleLinkClick}>{t('journal')}</Link></li>
                  <li><Link className="dropdown-item text-white" to="/Webradio" onClick={handleLinkClick}>{t('webradio')}</Link></li>
                  <li><Link className="dropdown-item text-white" to="/arts" onClick={handleLinkClick}>{t('arts')}</Link></li>
                  <li><Link className="dropdown-item text-white" to="/EnConstruction" onClick={handleLinkClick}>{t('musique')}</Link></li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle text-white" href="#" data-bs-toggle="dropdown">
                  <FaCalendarAlt className="me-2" /> {t('news')}
                </a>
                <ul className="dropdown-menu bg-cyan">
                  <li><Link className="dropdown-item text-white" to="/Calendrier" onClick={handleLinkClick}>{t('calendar')}</Link></li>
                  <li><Link className="dropdown-item text-white" to="/News" onClick={handleLinkClick}>{t('News')}</Link></li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle text-white" href="#" data-bs-toggle="dropdown">
                  <FaBook className="me-2" /> {t('resources')}
                </a>
                <ul className="dropdown-menu bg-cyan">
                  <li><Link className="dropdown-item text-white" to="/Ressources" onClick={handleLinkClick}>{t('documents_guides')}</Link></li>
                  <li><Link className="dropdown-item text-white" to="/FAQ" onClick={handleLinkClick}>{t('faq')}</Link></li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="form-check form-switch ms-3">
            <input type="checkbox" id="themeSwitch" checked={isDarkMode} onChange={toggleTheme} />
            <label htmlFor="themeSwitch">
              {isDarkMode ? <MdDarkMode /> : <MdLightMode />}
            </label>
          </div>

          <div className="language-switcher ms-3">
            <button onClick={() => handleLanguageChange('fr')}><ReactCountryFlag countryCode="FR" svg /></button>
            <button onClick={() => handleLanguageChange('en')}><ReactCountryFlag countryCode="US" svg /></button>
            <button onClick={() => handleLanguageChange('jp')}><ReactCountryFlag countryCode="JP" svg /></button>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Top;
